export default "__VITE_ASSET__CJtaIFw1__"